const URL_REVOKE_DELAY = 1500; // ms

function triggerDownload(
    file: { data: string; name: string; },
    defaultName = ""
) {
    const anchor = document.createElement("a");
    anchor.href = file.data;
    anchor.download = file.name || defaultName;
    anchor.style.display = "none";

    document.body.appendChild(anchor);

    anchor.addEventListener("click", ev => {
        ev.stopPropagation();

        setTimeout(URL.revokeObjectURL, URL_REVOKE_DELAY, file.data);

        anchor.remove();
    });

    anchor.click();
}

export {
    triggerDownload
};
